import { EbiCondition, IEbiField, IEbiFormAttachment, IEbiFormSection } from "modules/ebiForms/typings";

// Bloki wspólne wniosków o materiały zasobu geodezyjnego (G1, G2) — wzory z rozporządzenia Ministra Finansów
// i Gospodarki z 28.07.2026 r. (Dz.U. 2026 poz. 1068): uzasadnienie dostępu do danych podmiotów EGiB (art. 24 ust. 5 PGiK;
// Formularz EGiB poz. 10, Formularze P2 i P5 poz. 2) oraz informacja o opłacie ustalanej w Dokumencie Obliczenia Opłaty.

const ACCESS = "podstawaDostepu";
const LEGAL_INTEREST: EbiCondition = { field: ACCESS, equals: "interesPrawny" };

/** Podstawa dostępu do danych podmiotów EGiB — opcje dosłownie z wzoru; interes prawny wymaga wskazania przepisu i okoliczności. */
export const legalInterestSection = (visibleWhen: EbiCondition, title: string, description?: string): IEbiFormSection => ({
  code: "uzasadnienieDostepu",
  title,
  description,
  visibleWhen,
  fields: [
    {
      code: ACCESS,
      type: "radio",
      label: "Wnioskodawca",
      required: true,
      options: [
        {
          value: "wlasciciel",
          label: "jest właścicielem, osobą lub jednostką organizacyjną władającą gruntami, budynkami lub lokalami, których dotyczy wniosek",
        },
        {
          value: "organ",
          label:
            "jest organem administracji publicznej albo podmiotem niebędącym organem administracji publicznej, realizującym zadania publiczne związane z gruntami, budynkami lub lokalami, których dotyczy wniosek",
        },
        {
          value: "operatorSieci",
          label: "jest operatorem sieci w rozumieniu ustawy z dnia 7 maja 2010 r. o wspieraniu rozwoju usług i sieci telekomunikacyjnych",
        },
        {
          value: "operatorSystemu",
          label:
            "jest operatorem systemu przesyłowego, systemu dystrybucyjnego oraz systemu połączonego w rozumieniu ustawy z dnia 10 kwietnia 1997 r. — Prawo energetyczne",
        },
        { value: "sad", label: "jest sądem prowadzącym postępowanie, dla którego potrzebne jest uzyskanie wnioskowanych dokumentów" },
        { value: "interesPrawny", label: "ma interes prawny w dostępie do danych objętych wnioskiem" },
      ],
    },
    {
      code: "interesPrawnyPodstawa",
      type: "text",
      label: "Interes prawny wynikający z",
      hint: "Nazwa aktu prawnego, oznaczenie publikatora tego aktu oraz oznaczenie jednostki redakcyjnej (przepis prawa materialnego).",
      required: true,
      visibleWhen: LEGAL_INTEREST,
      maxLength: 500,
    },
    {
      code: "interesPrawnyOkolicznosci",
      type: "textarea",
      label: "w związku z",
      hint: "Okoliczności faktyczne będące przesłankami zastosowania wskazanego przepisu prawa materialnego.",
      required: true,
      visibleWhen: LEGAL_INTEREST,
      maxLength: 3000,
    },
  ],
});

/** Dokument źródłowy interesu prawnego — widoczny tylko, gdy sekcja uzasadnienia jest widoczna i wybrano interes prawny. */
export const legalInterestAttachment = (sectionVisibleWhen: EbiCondition, required: boolean): IEbiFormAttachment => ({
  code: "interesPrawnyDokument",
  label: "Dokument potwierdzający interes prawny",
  hint: required
    ? "Np. umowa przedwstępna, postanowienie sądu — skan lub kopia."
    : "Nieobowiązkowo — np. umowa przedwstępna, postanowienie sądu; ułatwia ocenę interesu prawnego.",
  visibleWhen: { all: [sectionVisibleWhen, LEGAL_INTEREST] },
  required,
});

/** Opłata za udostępnienie materiałów zasobu: Dokument Obliczenia Opłaty, wpłata przed wydaniem, bez opłaty skarbowej. */
export const resourceFeeInfo = (code: string, tables: string): IEbiField => ({
  code,
  type: "info",
  label: `Opłatę za udostępnienie materiałów ustala organ w Dokumencie Obliczenia Opłaty (art. 40d ustawy — Prawo geodezyjne i kartograficzne) według ${tables} załącznika do ustawy; stawki podlegają corocznej waloryzacji. Materiały zostaną udostępnione po wniesieniu opłaty. Wniosek nie podlega opłacie skarbowej.`,
});
